import * as React from 'react';
import moment from 'moment';
import { CombinedFilterViewProps } from '../../components/filters-ace/filter';
import { scrollToMonth, removeLoader, getMonthElement } from '../../helpers/scroll-to-month';

const FilterView: React.StatelessComponent<CombinedFilterViewProps> = props => {
    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        // Grab the selected option's data-first-occurance attribute.
        const selectedValue = evt.currentTarget.value;
        const selectEl = evt.currentTarget;
        const selectedOption = selectEl.options[selectEl.selectedIndex];

        var updatedFilters = props.currentFilters.set(props.propertyToFilter, selectedOption.value);

        var name = "";
        if (updatedFilters.get('name')) {
            name = updatedFilters.get('name');
        }

        var location = "";
        if (updatedFilters.get('location')) {
            location = updatedFilters.get('location');
        }

        var category = "";
        if (updatedFilters.get('categories')) {
            category = updatedFilters.get('categories');
        }

        let filters = {};

        updatedFilters.forEach(function (value, key) {
            filters[key] = value
        });

        props.getFirstOccurenceDateForFilters(filters, props.lastMonthToLoad, props.lastLoadedMonth);
        props.selectFilter(selectedValue, true);

    }

    const collapsedFilterName = props.filterName.replace(/[^\w]|_/g, "");

    return (
        <li className="ace-cal-filter">
            {/*Hiding Label*/}
            {/*<label htmlFor={`Filter-${collapsedFilterName}`}>{props.filterName}</label>*/}
            <select value={props.selectedValue} onChange={onChange} id={`Filter-${collapsedFilterName}`}>
                <option value="">{props.noSelectionText}</option>
                {
                    props.options.map(option => <option key={`${option.value}${option.text}`} value={option.value} data-first-occurance={option.firstOccurance} > {option.text}</option>)
                }
            </select>
        </li>
    );
}

export default FilterView;